/** TR cep / sabit hat için basitleştirilmiş biçimleyici. Değer: `+90 5XX XXX XX XX` */

const MAX_DIGITS = 12 // 90 + 10 hane

export function phoneDigits(raw: string): string {
  return raw.replace(/\D/g, '')
}

/** Kullanıcı girişini 90XXXXXXXXXX digit zincirine indirger. */
export function normalizeTrPhoneDigits(raw: string): string {
  let digits = phoneDigits(raw)
  if (!digits) return ''

  if (digits.startsWith('00')) digits = digits.slice(2)
  if (digits.startsWith('0') && !digits.startsWith('00')) {
    digits = `90${digits.slice(1)}`
  }
  if (!digits.startsWith('90') && digits.startsWith('5')) {
    digits = `90${digits}`
  }
  if (!digits.startsWith('90') && digits.length <= 10) {
    digits = `90${digits}`
  }
  return digits.slice(0, MAX_DIGITS)
}

/** Görünen format: `+90 532 111 22 33` */
export function formatTrPhone(raw: string): string {
  const digits = normalizeTrPhoneDigits(raw)
  if (!digits) return ''

  const rest = digits.startsWith('90') ? digits.slice(2) : digits
  const parts = ['+90']
  if (rest.length > 0) parts.push(rest.slice(0, 3))
  if (rest.length > 3) parts.push(rest.slice(3, 6))
  if (rest.length > 6) parts.push(rest.slice(6, 8))
  if (rest.length > 8) parts.push(rest.slice(8, 10))
  return parts.join(' ')
}

export function isCompleteTrPhone(raw: string): boolean {
  return normalizeTrPhoneDigits(raw).length === MAX_DIGITS
}
